import { JSX } from "react";
import "../../../../App.scss";
import { appContext } from "../../../../AppContext";
import { SerendieSymbol } from "@serendie/symbols";
import { IconButton, Toast, toaster } from "@serendie/ui";
import { IbssComponent } from "../../../../Components/Core/BaseComponent/IbssComponent";
import { Button, ButtonBar, Card, Dialog, DialogContent, DialogFooter, GridContainer, GridItem, OnSectionUpdateHandler, RightButtons, TextArea, TextField } from "@iconics/components";

class EditScimSettings extends IbssComponent<IProps, IState>
{
    private get labels() { return appContext().labels; }

    constructor(props: IProps)
    {
        super(props);

        this.state = {
            identityProviderId: '',
            scimSecurityToken: '',

            scimAccessToken: '',
            hasPendingChanges: false,
            scimDialogOpen: false,
        };
    }


    public async componentDidUpdate(prevProps: Readonly<IProps>): Promise<void>
    {
        if (prevProps !== this.props)
        {
            this.setState({
                identityProviderId: this.props.identityProviderId,
                scimSecurityToken: this.props.scimSecurityToken,
                hasPendingChanges: this.props.hasPendingChanges
            })
        }
    }

    private async handleScimAccessTokenClick(): Promise<void>
    {
        const token = await appContext().fadxPlatformApiClientV2.v2.security.byTenancy.identityProviders.byId.generateAccessToken.post<string>({
            tenancy: appContext().tenantId,
            id: this.props.id,
        });

        this.setState({ scimAccessToken: token, scimDialogOpen: true });
    }

    private handleCopyScimToken(): void 
    {
        try
        {
            navigator.clipboard.writeText(this.state.scimAccessToken);
            toaster.create({
                title: appContext().labels.Platform_Toast_CopiedToClipboard,
                duration: 3000
            });
        }
        catch (error)
        {
            console.error(error);
        }
        
    }
    
    private async handleScimTokenDialogClosed(): Promise<void>
    {
        await this.setStateAsync({ scimDialogOpen: false })
        await this.props.reload();
    }

    private get isNew(): boolean
    {
        return this.props.id === 0;
    }

    public render(): JSX.Element
    {
        return (
            <>
                <Card
                    title={this.labels.Platform_IdentityProviders_SyncType_SCIMv2_Title}
                    subTitle={this.labels.Platform_IdentityProviders_SyncType_SCIMv2_SubTitle}
                    onSectionUpdate={i => this.props.onSectionUpdate(i)}
                >
                    <GridContainer>
                        <GridItem expanded={6}>
                            <TextField
                                value={this.state.identityProviderId}
                                disabled
                                label={this.labels.IdentityProvider_IdentityProviderId}
                                placeholder={this.labels.IdentityProvider_IdentityProviderId}
                            />
                        </GridItem>
                        <GridItem expanded={6}>
                            <TextField
                                value={this.state.scimSecurityToken}
                                disabled
                                onChange={i => this.setState({ scimSecurityToken: i.target.value })}
                                label={this.labels.IdentityProvider_ScimSecurityToken}
                                placeholder={this.labels.IdentityProvider_ScimSecurityToken}
                            />
                        </GridItem>
                        <GridItem>
                            { !this.isNew && 
                            <Button
                                disabled={this.state.hasPendingChanges}
                                styleType="outlined"
                                color="primary"
                                onClick={() => this.handleScimAccessTokenClick()}
                                title={this.state.hasPendingChanges ? this.labels.IdentityProvider_ScimAccessTokenButtonDisabled_Tooltip : ''}
                            >
                                {this.labels.IdentityProviders_ScimAccessToken}
                            </Button>}
                        </GridItem>
                    </GridContainer>
                </Card>
                <Dialog
                    isOpen={this.state.scimDialogOpen}
                    title={this.labels.IdentityProviders_ScimAccessTokenDialog_Title}
                    onOpenChange={() => this.handleScimTokenDialogClosed()}
                >
                    <DialogContent>
                        <>        
                            <GridContainer>
                                <GridItem expanded={10}>
                                    <TextArea
                                        readOnly
                                        value={this.state.scimAccessToken}
                                        
                                    />
                                </GridItem>
                                <GridItem expanded={2}>
                                    <IconButton 
                                        shape="rectangle"
                                        styleType="outlined"
                                        icon={<SerendieSymbol name={"clipboard"} />}
                                        onClick={() => this.handleCopyScimToken()}
                                    />
                                </GridItem>
                            </GridContainer>
                            <Toast toaster={toaster} />
                        </>
                    </DialogContent>
                    <DialogFooter>
                        <ButtonBar>
                            <RightButtons>
                                <Button
                                    onClick={() => this.handleScimTokenDialogClosed()}
                                >
                                    {this.labels.Platform_CommonAction_Ok}
                                </Button>
                            </RightButtons>
                        </ButtonBar>
                    </DialogFooter>

                </Dialog>
            </>
        );
    }


}

export default EditScimSettings;

export interface IProps
{
    id: number;
    reload(): Promise<void>;
    onSectionUpdate: OnSectionUpdateHandler;
    identityProviderId: string;
    scimSecurityToken: string;
    hasPendingChanges: boolean;
}

export interface IState
{
    identityProviderId: string;
    scimSecurityToken: string;
    scimAccessToken: string;
    hasPendingChanges: boolean;
    scimDialogOpen: boolean;
}